import { ContentRow } from '../ContentRow';
import { Proof } from './components/Proof';

export interface IDocumentsApproveMessageProps {
  message: string;
}

export const AgentWorkHonestlyProofs = ({ message }: IDocumentsApproveMessageProps) => {
  return (
    <ContentRow>
      <Proof text={message} />
    </ContentRow>
  );
};
